const _2PI = Math.PI * 2;

/**
 * elasticOutのイージング関数
 */
const elasticOutFunc = (amplitude, period) => {
  const _amplitude = amplitude >= 1 ? amplitude : 1;
  const param1 = period / _2PI;
  const param2 = param1 * Math.asin(1 / _amplitude);
  return (p) => {
    if (p === 0 || p === 1) return p;
    return (
      _amplitude * Math.pow(2, -10 * p) * Math.sin((p - param2) / param1) + 1
    );
  };
};

/**
 *
 * @param {Object} velocity velocity-animateのオブジェクト
 * @param {string} name 新しく追加するeasingの名前
 * @param { { amplitude?: number; period?: number } } settings elasticOutの設定値。初期値はamplitude:1, period:0.3
 */
export const addElasticOut = (
  velocity,
  name,
  settings = { amplitude: 1, period: 0.3 }
) => {
  const { amplitude, period } = settings;
  velocity.Easings[name] = elasticOutFunc(amplitude, period);
};
